export default __webpack_public_path__ + "static/media/table_Icon.d8b44f89.svg";